// Authentication
export const GENERATE_OTP = '/VendorPortal/v1/send/otp';
export const SEND_LOGIN_OTP = '/VendorPortal/v1/sendLoginOTP';
export const VERIFY_LOGIN = '/VendorPortal/v1/login';
export const LOGOUT = '/VendorPortal/v1/logout';
export const RESET_PASSWORD_VIA_LINK = '/VendorPortal/v1/resetPasswordViaLink';
export const RESET_PASSWORD = '/VendorPortal/v1/resetPassword';
export const FORGOT_PASSWORD = '/VendorPortal/forgotpassword';
export const ORG_DETAILS = '/VendorPortal/orgdetails';

// User Management
export const CREATE_VENDOR_USER = '/VendorPortal/vendoruser/create';
export const GET_VENDOR_USERS = '/VendorPortal/vendorusersget';
export const UPDATE_VENDOR_USER = '/VendorPortal/vendoruser/update';
export const DOWNLOAD_VENDOR_USERS = '/VendorPortal/vendorusers/download';
export const GET_ROLES_WITH_PERMISSIONS = '/VendorPortal/vendorusers/roles-with-permissions';

// Master data
export const GET_MASTER_DATA = '/VendorPortal/masterdata/fetch';

// Assigned Vehicles
export const GET_ASSIGNED_VEHICLES = '/VendorPortal/vehicle-list';
export const ADD_VEHICLE = '/VendorPortal/vehicle/create';
export const UPDATE_VEHICLE = '/VendorPortal/vehicle/update/';
export const FETCH_VEHICLE_DETAIL = '/VendorPortal/vehicle/details/';

// Assigned Drivers
export const GET_ASSIGNED_DRIVERS = '/VendorPortal/worker-list';

// Vehicle Request
export const GET_VEHICLE_REQUEST = '/VendorPortal/vehicle-requests/get';
export const GET_VEHICLE_REQUEST_COUNT = '/VendorPortal/vehicle-requests/bucket-metrics-count';
export const SEARCH_HUBS = '/VendorPortal/hub/search';
export const SEARCH_VEHICLE_MAKE = '/VendorPortal/vehicle-make';
export const ASSIGN_VEHICLE = '/VendorPortal/assign/vehicle';
export const REJECT_VEHICLE_REQUEST = '/VendorPortal/reject/vehicle-request';
export const FETCH_WORKER_DETAILS = '/VendorPortal/getWorkerInfo';
export const ACCEPT_INDENT_WITHOUT_ASSIGN = '/VendorPortal/indent/event/accept';
export const ACCEPT_INDENT_IST_WITHOUT_ASSIGN = '/VendorPortal/ist/indent/event/accept';
export const PRINT_FLM_LORRY_RECEIPT = '/VendorPortal/trip/v1/printFLMLorryReceipt';

// Vehicle Request MM
export const GET_VEHICLE_REQUEST_IST = '/VendorPortal/ist/vehicle-requests/get';
export const GET_VEHICLE_REQUEST_COUNT_IST = '/VendorPortal/ist/vehicle-requests/bucket-metrics-count';
export const ASSIGN_VEHICLE_IST = '/VendorPortal/ist/assign/vehicle';
export const REJECT_VEHICLE_REQUEST_IST = '/VendorPortal/ist/reject/vehicle-request';

// Trip Details
export const GET_TRIP_DETAILS_METADATA = '/VendorPortal/tripdetailsmetadata';
export const GET_TRIP_DETAILS = '/VendorPortal/tripdetails/get';
export const GET_IST_TRIP_DETAILS_METADATA = '/VendorPortal/ist/tripdetailsmetadata';

// Delivery Acknowledgment
export const GET_INVOICE_NUMBER_CONSIGNMENTS = '/VendorPortal/consignments/fetch';
export const GET_TASK_SIGNED_URL = '/VendorPortal/pod/generateTaskImageUrl';
export const INVOICE_SEARCH = '/VendorPortal/consignment/search';
export const UPDATE_INVOICE_POD_LIST = '/VendorPortal/pod/update';
export const MARK_CONSIGNMENT_DELIVERED = '/VendorPortal/consignments/markConsignmentAsDelivered';
export const MARK_CONSIGNMENT_UNDELIVERED = '/VendorPortal/consignments/markConsignmentAsUndelivered';
export const MARK_CONSIGNMENT_PICKUP_COMPLETED = '/VendorPortal/consignments/markConsignmentAsPickupCompleted';
export const MARK_CONSIGNMENT_NOT_PICKED_UP = '/VendorPortal/consignments/markConsignmentAsNotPickedUp';

// Delivery Acknowledgment MM
export const INVOICE_SEARCH_IST = '/VendorPortal/ist/consignment/search';
export const MARK_CONSIGNMENT_DELIVERED_IST = '/VendorPortal/ist/consignments/markConsignmentInScanAtHub';
export const MARK_CONSIGNMENT_UNDELIVERED_IST = '/VendorPortal/ist/consignments/markConsignmentAsException';

export const FETCH_TRIP_COMMENTS = '/VendorPortal/fetchTripComments';
export const POST_TRIP_COMMENT = '/VendorPortal/postTripComment';

export const GET_IMAGE_URL = '/VendorPortal/consignment/generateTaskImageUrl';

// Notifications
export const UPDATE_USER_PREFERENCE = '/VendorPortal/userPreference';
export const GET_NOTIFICATION_AUTH_TOKEN = '/VendorPortal/notification/getAuthToken';

// Firestore/Firebase
export const FCM_TOKEN_UPDATE = '/VendorPortal/fcm/updatetoken';

// Invoices
export const FETCH_ALL_INVOICES = '/VendorPortal/consignment-invoice/fetch';
export const FETCH_INVOICE_BUCKET_METRICS = '/VendorPortal/consignment-invoice/bucket-metrics-count';
export const UPLOAD_INVOICE_POD_SINGLE = '/VendorPortal/consignment-invoice/upload-pod/single';
export const VALIDATE_INVOICE_POD = '/VendorPortal/consignment-invoice/validate-pod';

// Image Upload S3
export const UPLOAD_IMAGE = '/VendorPortal/worker-enrollment/get-put-image-url';
export const GET_SIGNED_URL = '/VendorPortal/cloud-storage/generate-signed-read-url';

// Assigned Driver
export const GET_VENDOR_LIST = '/VendorPortal/getvendorlist';
export const CREATE_DRIVER = '/VendorPortal/worker/create';
export const VENDER_SEARCH_HUB_QUERY = '/VendorPortal/searchHubs';

// Assign Driver Vehicle Details
export const GET_WORKERS = '/VendorPortal/worker/get';
export const GET_VEHICLES = '/VendorPortal/vehicle/get';

// Address
export const FETCH_ADDRESS_HIERARCHY_DATA = '/VendorPortal/addressManagement/getHierarchyData';
export const GET_BOTTOM_UP_HIERARCHY_FOR_ADDRESS_NODE = '/VendorPortal/addressManagement/getBottomUpHierarchyForAddressNode';
export const FETCH_ADDRESS_META_DATA = '/VendorPortal/addressManagement/getAddressMetaData';

// Receivables
export const GET_RECEIVABLES_S3_SIGNED_URL = '/vendorInvoice/vendor/getS3SignedUrl';
export const UPDATE_INVOICE = '/VendorPortal/carrierInvoices/receivable/v1/update';
export const SETTLE_RECEIVABLES_INVOICE = '/vendorInvoice/vendor/settleInvoice';
export const RAISE_SETTLEMENT_DISPUTE = '/vendorInvoice/vendor/raiseSettlementDispute';
export const SUBMIT_INVOICE = '/vendorInvoice/vendor/submitInvoice';
export const ADD_COMMENT_FOR_INVOICE = '/vendorInvoice/vendor/comment/add';
export const FETCH_COMMENT_HISTORY = '/vendorInvoice/vendor/comment/fetch';
export const FETCH_EVENT_HISTORY = '/vendorInvoice/vendor/event/fetch';
export const GET_INVOICE_MASTER_DATA = '/vendorInvoice/vendor/masterdata';
export const GET_PAYOUT_MASTER_DATA = '/vendorPayout/vendor/masterdata';
export const FETCH_PAYOUTS = '/vendorPayout/vendor/fetchPayouts';
export const SEND_PAYOUT_FOR_REVIEW = '/vendorPayout/vendor/sendForReview';
export const BULK_SEND_PAYOUT_FOR_REVIEW = '/vendorPayout/vendor/bulkSendForReview';
export const GET_ACTIVE_ADHOC_CHARGES = '/vendorPayout/vendor/getActiveAdhocCharges';
export const GET_CONSIGNMENT_DETAILS = '/VendorPortal/tripdetails/getConsignmentDetails';
export const GET_S3_SIGNED_URL_ADHOC = '/vendorPayout/vendor/getS3SignedUrl';
export const ADD_ADHOC_CHARGES = '/vendorPayout/vendor/addAdhocCharges';
export const DOWNLOAD_PAYOUT_EXCEL = '/vendorPayout/vendor/downloadPayoutExcel';
export const DOWNLOAD_SAMPLE_ADHOC_CHARGES_EXCEL = '/vendorPayout/vendor/downloadSampleAdhocChargesExcel';
export const UPLOAD_BULK_ADHOC_CHARGES = '/vendorPayout/vendor/uploadBulkAdhocCharges';
export const PROCESS_SINGLE_ADHOC_CHARGE = '/vendorPayout/vendor/processSingleAdhocCharge';
export const DOWNLOAD_UPLOAD_REQUESTS_FILE = '/vendorPayout/vendor/downloadUploadRequestsFile';
export const FETCH_TRIP_REFERENCES_FOR_VEHICLE = '/VendorPortal/tripdetails/fetchTripListForVehicle';
export const FETCH_RECEIVABLES_INVOICE = '/vendorInvoice/vendor/fetchInvoices';
export const DOWNLOAD_RECEIVABLES_INVOICE = '/vendorInvoice/vendor/downloadInvoiceExcel';
export const FETCH_PAYOUT_EVENTS = '/vendorPayout/vendor/fetchPayoutEvents';

// Moveable Assets
export const GET_MOVEABLE_ASSETS = '/VendorPortal/moveable-asset/fetch';
export const CREATE_MOVEABLE_ASSET = '/VendorPortal/moveable-asset/create';
export const SEARCH_MOVEABLE_ASSETS = '/VendorPortal/moveable-asset/search';

// Ticketing Tool
export const ORG_CONFIG = '/orgconfig';

// Download Requests
export const FETCH_DOWNLOAD_REQUESTS = '/downloadhandler/fetchVendorDownloadRequests';
